<script setup>
import SelectField from '../Form/SelectField.vue';
import languages from '@/languages.js';
import { normalizeLang } from '@/helpers';
import { ref, watch, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAuthStore } from '@/stores/auth';
import { storeToRefs } from 'pinia';

const { t } = useI18n()
const auth = useAuthStore()
const { getUser } = storeToRefs(auth)

const lang = ref(normalizeLang(
  localStorage.getItem('lang') || getUser?.value?.def_lang || navigator.language || navigator.userLanguage
))

watch(lang, (val) => {
  localStorage.setItem('lang', normalizeLang(val))
  window.location.reload()
})

const translatedLanguages = computed(() => {
  return languages.map(lang => ({
    cod: lang.cod,
    nm: t(`language.${lang.cod}`) 
  }));
});
</script>

<template>
  <div class="max-w-xl">
    <SelectField 
      :options="translatedLanguages"
      v-model="lang"
      text-attribute="nm"
      value-attribute="cod"
      class="text-sm w-full"
    />
  </div>
</template>
